export default {
    name: 'ILayoutAside'
};
